// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__I71qp","title":"AfterFrontImage_title__1beTT"};